var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M40 0H0V40H40V0Z","fill":"white","style":{"fill":"white","fillOpacity":"1"},"key":0}),React.createElement("path",{"d":"M10 18.571H18.571V10H10V18.571ZM12.857 12.857H15.714V15.714H12.857V12.857ZM21.429 10V18.571H30V10H21.429ZM27.143 15.714H24.286V12.857H27.143V15.714ZM10 30H18.571V21.429H10V30ZM12.857 24.286H15.714V27.143H12.857V24.286ZM28.571 21.429H30V27.143H25.714V25.714H24.286V30H21.429V21.429H25.715V22.858H28.572L28.571 21.429ZM28.571 28.572H30V30H28.571V28.572ZM25.714 28.572H27.143V30H25.714V28.572Z","fill":"black","style":{"fill":"black","fillOpacity":"1"},"key":1})]);
}

Icon.defaultProps = {"width":"46","height":"38","viewBox":"0 0 46 38","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
